import { render, staticRenderFns } from "./BookingProject.vue?vue&type=template&id=6e8452ec&scoped=true&"
import script from "./BookingProject.vue?vue&type=script&lang=ts&"
export * from "./BookingProject.vue?vue&type=script&lang=ts&"
import style0 from "./BookingProject.vue?vue&type=style&index=0&id=6e8452ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8452ec",
  null
  
)

export default component.exports